import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { modelClass } from '/imports/api/buyTargets';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { PageHeading } from '/imports/ui/PageHeading';
import { Button } from '/imports/ui/Button';
import { Icon } from '/imports/ui/Icon';
import { strings } from '/imports/strings';
import { BuyTargetsBulkModal } from '/imports/ui/BuyTargetsBulkModal';
import { useUser } from '/imports/hooks';

const BuyTargetsHeader = () => {
  const { pathPrefix, pluralName, icon } = modelClass;
  const [bulkOpen, setBulkOpen] = useState(false);
  return (
    <>
      <PageHeading
        left={<h1>{icon && <Icon icon={icon} /> || null}{pluralName}</h1>}
        right={
          <div>
            <Button className="btn secondary" onClick={() => setBulkOpen(true)}>Bulk</Button>
            <Link to={`${pathPrefix}/new`}>
              <Button className="btn primary">{strings.New()}</Button>
            </Link>
          </div>
        }
      />
      {bulkOpen && <BuyTargetsBulkModal onClose={() => setBulkOpen(false)} />}
    </>
  );
};

export const BuyTargetsPage = () => (
  <ModelListPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    header={<BuyTargetsHeader />}
    columns={[{ field: 'cardId', label: 'Card ID' }, { field: 'card', label: 'Card' }, { field: 'priority', label: 'Priority' }, { field: 'buycap', label: 'Buy Cap' }]}
  />
);

// keep unused import live so tree-shaking doesn't drop the hook
void useUser;
